module.exports = __webpack_public_path__ + "static/media/documentDownload.b8e5cdbd.svg";